// @ts-nocheck
import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy, Component, ElementRef, Inject, Injectable, Input, Optional, Renderer2,
} from '@angular/core';
import { UIKitIconName } from '../../icon/icon';

import { UIKitIconRegistry } from '../../icon/icon.registry';

@Component({
  selector: 'lib-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  exportAs: 'libIcon',
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconComponent {
  @Input() size: 'large' | 'normal' | 'small' = 'normal';

  @Input() set theme(
    theme:
      | 'primary'
      | 'accent'
      | 'warn'
      | 'link'
      | 'reverse'
      | 'none',
  ) {
    this.element.nativeElement.setAttribute('class', theme);
  }

  @Input()
  set name(name: UIKitIconName) {
    if (this.svgElement) {
      this.element.nativeElement.removeChild(this.svgElement);
    }

    const data = this.iconRegistry.getIcon(name);

    this.svgElement = this.svgElementFromString(data);

    this.element.nativeElement.appendChild(this.svgElement);
  }

  private svgElement: SVGElement;

  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
    private iconRegistry: UIKitIconRegistry,
    // @Optional() @Inject(DOCUMENT) private document: any,
  ) { }

  /**
   *
   */
  private svgElementFromString(data: string): SVGElement {
    //
    const div: HTMLDivElement = /* (this.document || document) */ document?.createElement('div');
    div.innerHTML = data;
    const svgElement = div.querySelector('svg') as SVGElement
      /* (this.document || document) */ || document?.createElementNS('http://www.w3.org/2000/svg', 'path');

    //
    return svgElement;
  }
}
